/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPayorSourceSummary } from './HchbPayorSourceSummary';
import {
    HchbPayorSourceSummaryFromJSON,
    HchbPayorSourceSummaryFromJSONTyped,
    HchbPayorSourceSummaryToJSON,
    HchbPayorSourceSummaryToJSONTyped,
} from './HchbPayorSourceSummary';

/**
 * 
 * @export
 * @interface HchbPayorSourcePage
 */
export interface HchbPayorSourcePage {
    /**
     * 
     * @type {Array<HchbPayorSourceSummary>}
     * @memberof HchbPayorSourcePage
     */
    data: Array<HchbPayorSourceSummary>;
    /**
     * 
     * @type {number}
     * @memberof HchbPayorSourcePage
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof HchbPayorSourcePage
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof HchbPayorSourcePage
     */
    total: number;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPayorSourcePage
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the HchbPayorSourcePage interface.
 */
export function instanceOfHchbPayorSourcePage(value: object): value is HchbPayorSourcePage {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function HchbPayorSourcePageFromJSON(json: any): HchbPayorSourcePage {
    return HchbPayorSourcePageFromJSONTyped(json, false);
}

export function HchbPayorSourcePageFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorSourcePage {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HchbPayorSourceSummaryFromJSON)),
        'page': json['page'],
        'limit': json['limit'],
        'total': json['total'],
        'has_next': json['has_next'],
    };
}

export function HchbPayorSourcePageToJSON(json: any): HchbPayorSourcePage {
    return HchbPayorSourcePageToJSONTyped(json, false);
}

export function HchbPayorSourcePageToJSONTyped(value?: HchbPayorSourcePage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(HchbPayorSourceSummaryToJSON)),
        'page': value['page'],
        'limit': value['limit'],
        'total': value['total'],
        'has_next': value['has_next'],
    };
}

